<template>
  <AbstractModalHeader class="px-2" :title="`Serwis ${ride.number}`">
    <template #prepend-item v-if="isMobile.value"><BackIconButton @click="$emit('close')"></BackIconButton></template>
  </AbstractModalHeader>
</template>

<script>
import AbstractModalHeader from '@/component/Dialog/abstract-modal-header';
import BackIconButton from '@/component/Button/back-icon-button';

export default {
  name: 'ServiceRideHeader',
  components: {
    AbstractModalHeader,
    BackIconButton,
  },
  inject: ['isMobile'],
  props: {
    ride: Object,
  },
};
</script>

<style lang="scss" scoped></style>
